export const PLATFORM_NAME_EN = 'ZERO BOX';
export const PLATFORM_NAME = '霖居';
export const PLATFORM_FULL_NAME = '霖居企業有限公司';
export const PLATFORM_TAX_NUMBER = '91024781';
export const PLATFORM_CONTACT_ADDRESS = '臺南市仁德區太乙路23號';
export const PLATFORM_CONTACT_NUMBER = '0930-899-079';
